import { createFileRoute } from '@tanstack/react-router'
import { CompanyChatList } from '@/features/company-chat'

export const Route = createFileRoute('/_authenticated/company-chat/')({
  component: CompanyChatList,
})
